import {useCallback, useEffect, useMemo, useState} from 'react';
import Icon from './Icon';

export const BALANCE_VISIBILITY_KEY = 'qolak:balances-visible';

export function balanceVisibilityKey(accountId) {
  const normalized = String(accountId ?? '').trim();
  return normalized ? `${BALANCE_VISIBILITY_KEY}:${normalized}` : BALANCE_VISIBILITY_KEY;
}

export function readBalanceVisibility(storage = globalThis.sessionStorage, accountId) {
  try {
    const saved = storage?.getItem(balanceVisibilityKey(accountId));
    return saved === null ? true : saved === 'true';
  } catch {
    return true;
  }
}

export function writeBalanceVisibility(visible, storage = globalThis.sessionStorage, accountId) {
  try { storage?.setItem(balanceVisibilityKey(accountId), String(Boolean(visible))); } catch {}
  return Boolean(visible);
}

export function clearBalanceVisibility(storage = globalThis.sessionStorage, accountId) {
  try { storage?.removeItem(balanceVisibilityKey(accountId)); } catch {}
}

export function useBalanceVisibility(accountId) {
  const key = useMemo(() => balanceVisibilityKey(accountId), [accountId]);
  const [visible, setVisible] = useState(() => readBalanceVisibility(globalThis.sessionStorage, accountId));
  useEffect(() => setVisible(readBalanceVisibility(globalThis.sessionStorage, accountId)), [key, accountId]);
  const toggle = useCallback(() => setVisible(current => writeBalanceVisibility(!current, globalThis.sessionStorage, accountId)), [accountId]);
  return {visible, hidden: !visible, toggle};
}

export function SensitiveValue({hidden, children, className = '', style}) {
  if (!hidden) return <span className={className} style={style}>{children}</span>;
  return (
    <span className={`qc-sensitive-value is-hidden ${className}`.trim()} style={style}>
      <span aria-hidden="true">••••</span>
      <span className="visually-hidden">مقدار پنهان است</span>
    </span>
  );
}

export function BalanceVisibilityButton({visible, onToggle}) {
  return (
    <button
      type="button"
      className="qc-balance-toggle"
      aria-pressed={!visible}
      aria-label={visible ? 'پنهان‌کردن موجودی‌ها' : 'نمایش موجودی‌ها'}
      title={visible ? 'پنهان‌کردن موجودی‌ها' : 'نمایش موجودی‌ها'}
      onClick={onToggle}
    >
      <Icon name={visible ? 'eye' : 'eyeOff'} size={20}/>
      <span>{visible ? 'پنهان‌کردن موجودی' : 'نمایش موجودی'}</span>
    </button>
  );
}
